module.exports = __webpack_public_path__ + "static/media/3DPPA22.37fc550e.jpg";